<template>
  <section class="m-setting-clause m-scroll">
    <!-- 头部导航 -->
    <m-header title="Clause" ></m-header>
    <div class="main">
        <img v-for="(item, index) in imgs" :src="item" :key="index" alt="img">
    </div>
  </section>
</template>

<script>
import MHeader  from '@/components/zh/m-header.vue'

export default {
  name:'Clause',
  components:{ MHeader },
  data(){
    return {
      imgs: [
          require('@/assets/setting/f/1.png'),
          require('@/assets/setting/f/2.png'),
          require('@/assets/setting/f/3.png'),
          require('@/assets/setting/f/4.png'),
          require('@/assets/setting/f/5.png'),
          require('@/assets/setting/f/6.png'),
          require('@/assets/setting/f/7.png'),
          require('@/assets/setting/f/8.png'),
          require('@/assets/setting/f/9.png'),
          require('@/assets/setting/f/10.png'),
          require('@/assets/setting/f/11.png'),
          require('@/assets/setting/f/12.png'),
          require('@/assets/setting/f/13.png'),
          require('@/assets/setting/f/14.png'),
          require('@/assets/setting/f/15.png'),
          require('@/assets/setting/f/16.png'),
          require('@/assets/setting/f/17.png'),
          require('@/assets/setting/f/18.png'),
          require('@/assets/setting/f/19.png'),
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.m-setting-clause {
  width: 100%;
  height: 100%;
  background-color: #F5F9FF;
  padding-top:44px;
  overflow-y: auto;
  .main {
    margin-top: 12px;
    width: 100%;
    padding: 0 16px;
    font-size: 0;
    img{width:100%}
  }
}
</style>